import usePassengerInformationFormStep3 from '../../../../../viewModels/flights/passenger.information.form.step3.viewModel';
import ActivityIndicator from '../../../../share/components/activityIndicator';
import SvgIcon, { iconList } from '../../../../share/components/iconSVG';
import '../../styles.css';
import './stylesStep3.css';
import PaymentCards from '../../../../profileUser/components/paymentCards';
import ModalContainer from '../../../../share/components/modalContainer';

function Step3({
  userDetail,
  userToken,
  location,
  PNR,
  dataSavePNR,
}) {

  const {
    step,
    setStep,
    stepList,
    paymentCardSelected,
    setPaymentCardSelected,
    form,
    getEvent,
    generateTicketData,
    isFetching,
    showModalTicket,
    setShowModalTicket,
    email,
    reset,
    message
  } = usePassengerInformationFormStep3(
    userDetail,
    userToken,
    location,
    PNR,
    dataSavePNR
  );
  return (
    <>
      <ModalContainer
        show={showModalTicket}
        hidden={reset}
        sizeWidth={40}
        sizeHeight={40}
      >
        <div className='step3ModalTicket'>

        {message?.statusOK
        ? <SvgIcon color={'green'} name={iconList?.IconCheckSucces} size={120} />
        : <SvgIcon color={'red'} name={iconList?.IconCloseCircleOutLine} size={120} />
      }
         
          <p className='step3ModalTicketTitle'>{message?.text1}</p>
          <p className='step3ModalTicketDescription'>{message?.text2}</p>
        </div>
      </ModalContainer>

      <div className='pifsStepContainer' id={'step3'}>

        <div className='stepByStep'>
          {
            stepList && stepList.map((index, key) => {
              const isActive = step === index?.id
              return (
                <div key={key} onClick={() => setStep(index?.id)}
                  className={`stepByStepOpt ${isActive ? 'stepByStepOptOn' : 'stepByStepOptOff'}`}>
                  <p className={`stepByStepOptText`}>
                    {index?.title}{key + 1 < stepList.length && ' / '}
                  </p>
                </div>
              )
            })
          }
        </div>

        {step === 1 &&
          <div className='stepContainer'>
            <PaymentCards
              selected={paymentCardSelected}
              selectItem={setPaymentCardSelected}
            />
            <div>
              <div onClick={() => generateTicketData()}
                className={`pifsFormFootBtn ${paymentCardSelected ? 'pifsFormFootBtnOn' : 'pifsFormFootBtnOff'}`}
              >
                <p className='pifsFormFootBtnText'>Finalizar</p>
              </div>
            </div>
          </div>
        }

        {/* {step === 2 &&
          <div className='stepContainer'>
            <div className='listCardHeader'>
              <p className='listCardHeaderText'>ingresar codigo CVC de la tarjeta seleccionada</p>
            </div>
            <div className='pifsFormBodyInputsLabelContainerCenter' style={{ width: 200 }}>
              <input
                id={'codeCVC'}
                placeholder='CVC'
                value={`${form?.codeCVC}`}
                onChange={getEvent}
                className='pifsFormBodyInputsLabelContainerInput'
              />
            </div>
            <div className='listCardFooter'>
              <div onClick={() => setStep(1)} className={`pifsFormFootBtn pifsFormFootBtnOn`} >
                <p className='pifsFormFootBtnText'>Volver</p>
              </div>
              <div onClick={() => generateTicketData(3)}
                className={`pifsFormFootBtn ${form?.codeCVC.length > 2 ? 'pifsFormFootBtnOn' : 'pifsFormFootBtnOff'}`}>
                <p className='pifsFormFootBtnText'>Finalizar</p>
              </div>
            </div>
          </div>
        } */}

{/* 
        {step === 3 &&
          <div className='stepContainer'>
            <div className='listCardHeader'>
              <p className='listCardHeaderText'>Solo estas a un paso de finalizar</p>
            </div>
            <div className='pifsFormBodyInputsStepsContainer'>
              <p className='pifsFormBodyInputsLabel'>ingresar una description</p>
              <div className='pifsFormBodyInputsLabelContainerCenter'>
                <input
                  id={'description'}
                  placeholder='description'
                  value={`${form?.description}`}
                  onChange={getEvent}
                  className='pifsFormBodyInputsLabelContainerInput'
                />
              </div>
            </div>
            <br />
            <div className='pifsFormBodyInputsStepsContainer'>
              <p className='pifsFormBodyInputsLabel'>ingresar una referencia</p>
              <div className='pifsFormBodyInputsLabelContainerCenter'>
                <input
                  id={'reference'}
                  placeholder='referencia'
                  value={`${form?.reference}`}
                  onChange={getEvent}
                  className='pifsFormBodyInputsLabelContainerInput'
                />
              </div>
            </div>
            <div className='listCardFooter'>
              <div onClick={() => setStep(2)}
                className={`pifsFormFootBtn pifsFormFootBtnOn`}
              >
                <p className='pifsFormFootBtnText'>Volver</p>
              </div>
              <div onClick={() => generateTicketData()}
                className={`pifsFormFootBtn ${form?.description.length > 2 && form?.reference.length > 2 ? 'pifsFormFootBtnOn' : 'pifsFormFootBtnOff'}`}>
                {isFetching
                  ? <ActivityIndicator colorFill='#FFFFFF' size={15} />
                  : <p className='pifsFormFootBtnText'>Finalizar</p>
                }
              </div>
            </div>
          </div>
        } */}



      </div>
    </>
  )
}

export default Step3;
